'use client';
import '../datetime/constants.js';
import { toDate } from '../datetime/converters.js';
import 'date-fns';
import '../datetime/comparators.js';

/**
 * Format a time
 * @param date - The date to format
 * @param options - The options to use
 * @param options.excludeTimeZone - Whether to exclude the time zone [default: false]
 * @returns The formatted time
 */
const formatTime = (date, options = {}) => toDate(date).toLocaleTimeString(undefined, {
    ...(options.excludeTimeZone ? {} : { timeZoneName: 'short' }),
    hour: 'numeric',
    minute: '2-digit',
});

export { formatTime };
//# sourceMappingURL=format-time.js.map
